import gql from 'graphql-tag';

import type { GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_inProgress as InProgressCourseState } from 'bundles/degree-home/components/v2/UpcomingCourses/__generated__/getUpcomingCourseStatesQuery';
import type { DegreeCourse } from 'bundles/degree-home/types/Course';
import { getHomeUrl } from 'bundles/ondemand/utils/url';

export function getCourseLink(course: DegreeCourse | InProgressCourseState): string {
  return getHomeUrl(`/learn/${course.slug}`);
}
getCourseLink.fragment = gql`
  fragment CourseLinkFragment on DegreeLearnerProgressesV1_org_coursera_degree_learner_sequence_Course {
    slug
  }
`;
